import {
  Activity,
  Apple,
  Award,
  Baby,
  BadgeCheck,
  Bed,
  BedDouble,
  BicepsFlexed,
  Bike,
  Bot,
  Boxes,
  Brain,
  Briefcase,
  BuildingComplex,
  Calculator,
  Calendar,
  CalendarCheck,
  CalendarClock,
  Camera,
  Car,
  Cat,
  ChartColumn,
  Check,
  ClipboardCheck,
  ClipboardList,
  ClipboardPen,
  Clock,
  Cloud,
  Code,
  Coffee,
  Compass,
  ConciergeBell,
  Cpu,
  Crosshair,
  Dog,
  Droplets,
  Dumbbell,
  FaceSlightlySmiling,
  FaceSlightlySmilingPlus,
  FileLock,
  Flame,
  FlaskConical,
  Flower2,
  Footprints,
  Gauge,
  Gavel,
  Globe,
  HandFist,
  HandHeart,
  Handshake,
  HardHat,
  Headset,
  Heart,
  HeartHandshake,
  HeartPulse,
  Hospital,
  Hourglass,
  House,
  IdCard,
  KeyRound,
  Lamp,
  Landmark,
  Layers,
  LayoutDashboard,
  Leaf,
  Lock,
  Luggage,
  MapPin,
  Medal,
  MessageCircleQuestionMark,
  Microscope,
  Moon,
  Mountain,
  Music,
  PawPrint,
  PersonStanding,
  Pill,
  Plane,
  Plug,
  Receipt,
  Ruler,
  Sailboat,
  Salad,
  Scale,
  ScanEye,
  ScrollText,
  ShieldCheck,
  ShieldPlus,
  Ship,
  ShoppingBag,
  ShowerHead,
  Siren,
  Sparkles,
  Sprout,
  SquareParking,
  Star,
  Stethoscope,
  Sun,
  Sunrise,
  Swords,
  Syringe,
  Target,
  Timer,
  TrendingUp,
  TriangleAlert,
  Trophy,
  UserCheck,
  Users,
  UsersRound,
  Utensils,
  UtensilsCrossed,
  Waves,
  Weight,
  Wheat,
  Wind,
  Wine,
  Workflow,
  Wrench,
  Zap,
  type LucideIcon,
} from "lucide-react";
import type { IconName } from "../../content/industry";

/**
 * Iconos de la librería Lucide (lucide.dev, licencia ISC, gratuita). Para usar uno nuevo: búscalo en lucide.dev/icons,
 * agrega su nombre a IconName en content/industry.ts e impórtalo aquí desde "lucide-react". No uses emojis: se ven
 * distintos en cada sistema y no son accesibles.
 */
export const icons: Record<IconName, LucideIcon> = {
  shield: ShieldCheck,
  clock: Clock,
  spark: Sparkles,
  leaf: Leaf,
  chart: ChartColumn,
  users: Users,
  tool: Wrench,
  globe: Globe,
  heart: Heart,
  check: Check,
  map: MapPin,
  cup: Coffee,
  code: Code,
  lock: Lock,
  bolt: Zap,
  home: House,
  star: Star,
  plane: Plane,
  activity: Activity,
  apple: Apple,
  award: Award,
  baby: Baby,
  "badge-check": BadgeCheck,
  bed: Bed,
  "bed-double": BedDouble,
  "biceps-flexed": BicepsFlexed,
  bike: Bike,
  bot: Bot,
  boxes: Boxes,
  brain: Brain,
  briefcase: Briefcase,
  "building-complex": BuildingComplex,
  calculator: Calculator,
  calendar: Calendar,
  "calendar-check": CalendarCheck,
  "calendar-clock": CalendarClock,
  camera: Camera,
  car: Car,
  cat: Cat,
  "clipboard-check": ClipboardCheck,
  "clipboard-list": ClipboardList,
  "clipboard-pen": ClipboardPen,
  cloud: Cloud,
  coffee: Coffee,
  compass: Compass,
  "concierge-bell": ConciergeBell,
  cpu: Cpu,
  crosshair: Crosshair,
  dog: Dog,
  droplets: Droplets,
  dumbbell: Dumbbell,
  "face-slightly-smiling": FaceSlightlySmiling,
  "face-slightly-smiling-plus": FaceSlightlySmilingPlus,
  "file-lock": FileLock,
  flame: Flame,
  "flask-conical": FlaskConical,
  "flower-2": Flower2,
  footprints: Footprints,
  gauge: Gauge,
  gavel: Gavel,
  "hand-fist": HandFist,
  "hand-heart": HandHeart,
  handshake: Handshake,
  "hard-hat": HardHat,
  headset: Headset,
  "heart-handshake": HeartHandshake,
  "heart-pulse": HeartPulse,
  hospital: Hospital,
  hourglass: Hourglass,
  house: House,
  "id-card": IdCard,
  "key-round": KeyRound,
  lamp: Lamp,
  landmark: Landmark,
  layers: Layers,
  "layout-dashboard": LayoutDashboard,
  luggage: Luggage,
  medal: Medal,
  "message-circle-question-mark": MessageCircleQuestionMark,
  microscope: Microscope,
  moon: Moon,
  mountain: Mountain,
  music: Music,
  "paw-print": PawPrint,
  "person-standing": PersonStanding,
  pill: Pill,
  plug: Plug,
  receipt: Receipt,
  ruler: Ruler,
  sailboat: Sailboat,
  salad: Salad,
  scale: Scale,
  "scan-eye": ScanEye,
  "scroll-text": ScrollText,
  "shield-check": ShieldCheck,
  "shield-plus": ShieldPlus,
  ship: Ship,
  "shopping-bag": ShoppingBag,
  "shower-head": ShowerHead,
  siren: Siren,
  sparkles: Sparkles,
  sprout: Sprout,
  "square-parking": SquareParking,
  stethoscope: Stethoscope,
  sun: Sun,
  sunrise: Sunrise,
  swords: Swords,
  syringe: Syringe,
  target: Target,
  timer: Timer,
  "trending-up": TrendingUp,
  "triangle-alert": TriangleAlert,
  trophy: Trophy,
  "user-check": UserCheck,
  "users-round": UsersRound,
  utensils: Utensils,
  "utensils-crossed": UtensilsCrossed,
  waves: Waves,
  weight: Weight,
  wheat: Wheat,
  wind: Wind,
  wine: Wine,
  workflow: Workflow,
  wrench: Wrench,
  zap: Zap,
};

export function Icon({ name, size = 24, className = "ix-icon" }: { name: IconName; size?: number; className?: string }) {
  const Glyph = icons[name] ?? icons.check;
  return <Glyph className={className} size={size} strokeWidth={1.75} aria-hidden="true" focusable="false" />;
}
